import { ChainId as G } from "@deorderbook/contracts";
import { $fetch as Ue } from "ofetch";
var Y = {
  NAME: "Name",
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  DIRECTIVE: "Directive",
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType"
};
class ce extends Error {
  constructor(r, t, n, i, a, o, l) {
    super(r), this.name = "GraphQLError", this.message = r, a && (this.path = a), t && (this.nodes = Array.isArray(t) ? t : [t]), n && (this.source = n), i && (this.positions = i), o && (this.originalError = o);
    var u = l;
    if (!u && o) {
      var p = o.extensions;
      p && typeof p == "object" && (u = p);
    }
    this.extensions = u || {};
  }
  toJSON() {
    return {
      ...this,
      message: this.message
    };
  }
  toString() {
    return this.message;
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
}
var g, f;
function E(e) {
  return new ce(`Syntax Error: Unexpected token at ${f} in ${e}`);
}
function S(e) {
  if (e.lastIndex = f, e.test(g))
    return g.slice(f, f = e.lastIndex);
}
var H = / +(?=[^\s])/y;
function Ge(e) {
  for (var r = e.split(`
`), t = "", n = 0, i = 0, a = r.length - 1, o = 0; o < r.length; o++)
    H.lastIndex = 0, H.test(r[o]) && (o && (!n || H.lastIndex < n) && (n = H.lastIndex), i = i || o, a = o);
  for (var l = i; l <= a; l++)
    l !== i && (t += `
`), t += r[l].slice(n).replace(/\\"""/g, '"""');
  return t;
}
function v() {
  for (var e = 0 | g.charCodeAt(f++); e === 9 || e === 10 || e === 13 || e === 32 || e === 35 || e === 44 || e === 65279; e = 0 | g.charCodeAt(f++))
    if (e === 35)
      for (; (e = g.charCodeAt(f++)) !== 10 && e !== 13; )
        ;
  f--;
}
var b = /[_A-Za-z]\w*/y, oe = new RegExp("(?:(null|true|false)|\\$(" + b.source + ')|(-?\\d+)((?:\\.\\d+)?[eE][+-]?\\d+|\\.\\d+)?|("""(?:"""|(?:[\\s\\S]*?[^\\\\])"""))|("(?:"|[^\\r\\n]*?[^\\\\]"))|(' + b.source + "))", "y"), P = function(e) {
  return e[e.Const = 1] = "Const", e[e.Var = 2] = "Var", e[e.Int = 3] = "Int", e[e.Float = 4] = "Float", e[e.BlockString = 5] = "BlockString", e[e.String = 6] = "String", e[e.Enum = 7] = "Enum", e;
}(P || {}), Qe = /\\/g;
function z(e) {
  var r, t;
  if (oe.lastIndex = f, g.charCodeAt(f) === 91) {
    f++, v();
    for (var n = []; g.charCodeAt(f) !== 93; )
      n.push(z(e));
    return f++, v(), {
      kind: "ListValue",
      values: n
    };
  } else if (g.charCodeAt(f) === 123) {
    f++, v();
    for (var i = []; g.charCodeAt(f) !== 125; ) {
      if ((r = S(b)) == null || (v(), g.charCodeAt(f++) !== 58))
        throw E("ObjectField");
      v(), i.push({
        kind: "ObjectField",
        name: {
          kind: "Name",
          value: r
        },
        value: z(e)
      });
    }
    return f++, v(), {
      kind: "ObjectValue",
      fields: i
    };
  } else if ((t = oe.exec(g)) != null) {
    if (f = oe.lastIndex, v(), (r = t[P.Const]) != null)
      return r === "null" ? {
        kind: "NullValue"
      } : {
        kind: "BooleanValue",
        value: r === "true"
      };
    if ((r = t[P.Var]) != null) {
      if (e)
        throw E("Variable");
      return {
        kind: "Variable",
        name: {
          kind: "Name",
          value: r
        }
      };
    } else if ((r = t[P.Int]) != null) {
      var a;
      return (a = t[P.Float]) != null ? {
        kind: "FloatValue",
        value: r + a
      } : {
        kind: "IntValue",
        value: r
      };
    } else {
      if ((r = t[P.BlockString]) != null)
        return {
          kind: "StringValue",
          value: Ge(r.slice(3, -3)),
          block: !0
        };
      if ((r = t[P.String]) != null)
        return {
          kind: "StringValue",
          value: Qe.test(r) ? JSON.parse(r) : r.slice(1, -1),
          block: !1
        };
      if ((r = t[P.Enum]) != null)
        return {
          kind: "EnumValue",
          value: r
        };
    }
  }
  throw E("Value");
}
function Le(e) {
  if (g.charCodeAt(f) === 40) {
    var r = [];
    f++, v();
    var t;
    do {
      if ((t = S(b)) == null || (v(), g.charCodeAt(f++) !== 58))
        throw E("Argument");
      v(), r.push({
        kind: "Argument",
        name: {
          kind: "Name",
          value: t
        },
        value: z(e)
      });
    } while (g.charCodeAt(f) !== 41);
    return f++, v(), r;
  }
}
function B(e) {
  if (g.charCodeAt(f) === 64) {
    var r = [], t;
    do {
      if (f++, (t = S(b)) == null)
        throw E("Directive");
      v(), r.push({
        kind: "Directive",
        name: {
          kind: "Name",
          value: t
        },
        arguments: Le(e)
      });
    } while (g.charCodeAt(f) === 64);
    return r;
  }
}
function Je() {
  for (var e, r = 0; g.charCodeAt(f) === 91; )
    r++, f++, v();
  if ((e = S(b)) == null)
    throw E("NamedType");
  v();
  var t = {
    kind: "NamedType",
    name: {
      kind: "Name",
      value: e
    }
  };
  do
    if (g.charCodeAt(f) === 33 && (f++, v(), t = {
      kind: "NonNullType",
      type: t
    }), r) {
      if (g.charCodeAt(f++) !== 93)
        throw E("NamedType");
      v(), t = {
        kind: "ListType",
        type: t
      };
    }
  while (r--);
  return t;
}
var se = new RegExp("(?:(\\.{3})|(" + b.source + "))", "y"), fe = function(e) {
  return e[e.Spread = 1] = "Spread", e[e.Name = 2] = "Name", e;
}(fe || {});
function Z() {
  var e = [], r, t;
  do
    if (se.lastIndex = f, (t = se.exec(g)) != null) {
      if (f = se.lastIndex, t[fe.Spread] != null) {
        v();
        var n = S(b);
        if (n != null && n !== "on")
          v(), e.push({
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: n
            },
            directives: B(!1)
          });
        else {
          if (v(), n === "on") {
            if ((n = S(b)) == null)
              throw E("NamedType");
            v();
          }
          var i = B(!1);
          if (g.charCodeAt(f++) !== 123)
            throw E("InlineFragment");
          v(), e.push({
            kind: "InlineFragment",
            typeCondition: n ? {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: n
              }
            } : void 0,
            directives: i,
            selectionSet: Z()
          });
        }
      } else if ((r = t[fe.Name]) != null) {
        var a = void 0;
        if (v(), g.charCodeAt(f) === 58) {
          if (f++, v(), a = r, (r = S(b)) == null)
            throw E("Field");
          v();
        }
        var o = Le(!1);
        v();
        var l = B(!1), u = void 0;
        g.charCodeAt(f) === 123 && (f++, v(), u = Z()), e.push({
          kind: "Field",
          alias: a ? {
            kind: "Name",
            value: a
          } : void 0,
          name: {
            kind: "Name",
            value: r
          },
          arguments: o,
          directives: l,
          selectionSet: u
        });
      }
    } else
      throw E("SelectionSet");
  while (g.charCodeAt(f) !== 125);
  return f++, v(), {
    kind: "SelectionSet",
    selections: e
  };
}
function He() {
  var e, r;
  if ((e = S(b)) == null || (v(), S(b) !== "on") || (v(), (r = S(b)) == null))
    throw E("FragmentDefinition");
  v();
  var t = B(!1);
  if (g.charCodeAt(f++) !== 123)
    throw E("FragmentDefinition");
  return v(), {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: e
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: r
      }
    },
    directives: t,
    selectionSet: Z()
  };
}
var We = /(?:query|mutation|subscription|fragment)/y;
function Ke(e) {
  var r, t, n;
  if (e && (v(), r = S(b), t = function() {
    if (v(), g.charCodeAt(f) === 40) {
      var a = [];
      f++, v();
      var o;
      do {
        if (g.charCodeAt(f++) !== 36 || (o = S(b)) == null)
          throw E("Variable");
        if (v(), g.charCodeAt(f++) !== 58)
          throw E("VariableDefinition");
        v();
        var l = Je(), u = void 0;
        g.charCodeAt(f) === 61 && (f++, v(), u = z(!0)), v(), a.push({
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: o
            }
          },
          type: l,
          defaultValue: u,
          directives: B(!0)
        });
      } while (g.charCodeAt(f) !== 41);
      return f++, v(), a;
    }
  }(), n = B(!1)), g.charCodeAt(f) === 123)
    return f++, v(), {
      kind: "OperationDefinition",
      operation: e || "query",
      name: r ? {
        kind: "Name",
        value: r
      } : void 0,
      variableDefinitions: t,
      directives: n,
      selectionSet: Z()
    };
}
function Ye(e, r) {
  return g = typeof e.body == "string" ? e.body : e, f = 0, function() {
    var n, i;
    v();
    var a = [];
    do
      if ((n = S(We)) === "fragment")
        v(), a.push(He());
      else if ((i = Ke(n)) != null)
        a.push(i);
      else
        throw E("Document");
    while (f < g.length);
    return {
      kind: "Document",
      definitions: a
    };
  }();
}
function x(e, r, t) {
  for (var n = "", i = 0; i < e.length; i++)
    i && (n += r), n += t(e[i]);
  return n;
}
function ze(e) {
  return JSON.stringify(e);
}
function Ze(e) {
  return `"""
` + e.replace(/"""/g, '\\"""') + `
"""`;
}
var C = `
`, _ = {
  OperationDefinition(e) {
    var r = e.operation;
    return e.name && (r += " " + e.name.value), e.variableDefinitions && e.variableDefinitions.length && (e.name || (r += " "), r += "(" + x(e.variableDefinitions, ", ", _.VariableDefinition) + ")"), e.directives && e.directives.length && (r += " " + x(e.directives, " ", _.Directive)), r !== "query" ? r + " " + _.SelectionSet(e.selectionSet) : _.SelectionSet(e.selectionSet);
  },
  VariableDefinition(e) {
    var r = _.Variable(e.variable) + ": " + L(e.type);
    return e.defaultValue && (r += " = " + L(e.defaultValue)), e.directives && e.directives.length && (r += " " + x(e.directives, " ", _.Directive)), r;
  },
  Field(e) {
    var r = e.alias ? e.alias.value + ": " + e.name.value : e.name.value;
    if (e.arguments && e.arguments.length) {
      var t = x(e.arguments, ", ", _.Argument);
      r.length + t.length + 2 > 80 ? r += "(" + (C += "  ") + x(e.arguments, C, _.Argument) + (C = C.slice(0, -2)) + ")" : r += "(" + t + ")";
    }
    return e.directives && e.directives.length && (r += " " + x(e.directives, " ", _.Directive)), e.selectionSet && (r += " " + _.SelectionSet(e.selectionSet)), r;
  },
  StringValue(e) {
    return e.block ? Ze(e.value).replace(/\n/g, C) : ze(e.value);
  },
  BooleanValue: (e) => "" + e.value,
  NullValue: (e) => "null",
  IntValue: (e) => e.value,
  FloatValue: (e) => e.value,
  EnumValue: (e) => e.value,
  Name: (e) => e.value,
  Variable: (e) => "$" + e.name.value,
  ListValue: (e) => "[" + x(e.values, ", ", L) + "]",
  ObjectValue: (e) => "{" + x(e.fields, ", ", _.ObjectField) + "}",
  ObjectField: (e) => e.name.value + ": " + L(e.value),
  Document(e) {
    return !e.definitions || !e.definitions.length ? "" : x(e.definitions, `

`, L);
  },
  SelectionSet: (e) => "{" + (C += "  ") + x(e.selections, C, L) + (C = C.slice(0, -2)) + "}",
  Argument: (e) => e.name.value + ": " + L(e.value),
  FragmentSpread(e) {
    var r = "..." + e.name.value;
    return e.directives && e.directives.length && (r += " " + x(e.directives, " ", _.Directive)), r;
  },
  InlineFragment(e) {
    var r = "...";
    return e.typeCondition && (r += " on " + e.typeCondition.name.value), e.directives && e.directives.length && (r += " " + x(e.directives, " ", _.Directive)), r += " " + _.SelectionSet(e.selectionSet);
  },
  FragmentDefinition(e) {
    var r = "fragment " + e.name.value;
    return r += " on " + e.typeCondition.name.value, e.directives && e.directives.length && (r += " " + x(e.directives, " ", _.Directive)), r + " " + _.SelectionSet(e.selectionSet);
  },
  Directive(e) {
    var r = "@" + e.name.value;
    return e.arguments && e.arguments.length && (r += "(" + x(e.arguments, ", ", _.Argument) + ")"), r;
  },
  NamedType: (e) => e.name.value,
  ListType: (e) => "[" + L(e.type) + "]",
  NonNullType: (e) => L(e.type) + "!"
}, L = (e) => _[e.kind](e);
function Xe(e) {
  return C = `
`, _[e.kind] ? _[e.kind](e) : "";
}
var Pe = () => {
}, A = Pe;
function T(e) {
  return {
    tag: 0,
    0: e
  };
}
function J(e) {
  return {
    tag: 1,
    0: e
  };
}
var Ne = () => typeof Symbol == "function" && Symbol.asyncIterator || "@@asyncIterator", er = (e) => e;
function V(e) {
  return (r) => (t) => {
    var n = A;
    r((i) => {
      i === 0 ? t(0) : i.tag === 0 ? (n = i[0], t(i)) : e(i[0]) ? t(i) : n(0);
    });
  };
}
function rr(e) {
  return (r) => (t) => r((n) => {
    n === 0 || n.tag === 0 ? t(n) : t(J(e(n[0])));
  });
}
function Re(e) {
  return (r) => (t) => {
    var n = [], i = A, a = !1, o = !1;
    r((l) => {
      o || (l === 0 ? (o = !0, n.length || t(0)) : l.tag === 0 ? i = l[0] : (a = !1, function(p) {
        var m = A;
        p((d) => {
          if (d === 0) {
            if (n.length) {
              var y = n.indexOf(m);
              y > -1 && (n = n.slice()).splice(y, 1), n.length || (o ? t(0) : a || (a = !0, i(0)));
            }
          } else d.tag === 0 ? (n.push(m = d[0]), m(0)) : n.length && (t(d), m(0));
        });
      }(e(l[0])), a || (a = !0, i(0))));
    }), t(T((l) => {
      if (l === 1) {
        o || (o = !0, i(1));
        for (var u = 0, p = n, m = n.length; u < m; u++)
          p[u](1);
        n.length = 0;
      } else {
        !o && !a ? (a = !0, i(0)) : a = !1;
        for (var d = 0, y = n, N = n.length; d < N; d++)
          y[d](0);
      }
    }));
  };
}
function tr(e) {
  return Re(er)(e);
}
function de(e) {
  return tr(or(e));
}
function Fe(e) {
  return (r) => (t) => {
    var n = !1;
    r((i) => {
      if (!n) if (i === 0)
        n = !0, t(0), e();
      else if (i.tag === 0) {
        var a = i[0];
        t(T((o) => {
          o === 1 ? (n = !0, a(1), e()) : a(o);
        }));
      } else
        t(i);
    });
  };
}
function ke(e) {
  return (r) => (t) => {
    var n = !1;
    r((i) => {
      if (!n) if (i === 0)
        n = !0, t(0);
      else if (i.tag === 0) {
        var a = i[0];
        t(T((o) => {
          o === 1 && (n = !0), a(o);
        }));
      } else
        e(i[0]), t(i);
    });
  };
}
function _e(e) {
  return (r) => (t) => r((n) => {
    n === 0 ? t(0) : n.tag === 0 ? (t(n), e()) : t(n);
  });
}
function Q(e) {
  var r = [], t = A, n = !1;
  return (i) => {
    r.push(i), r.length === 1 && e((a) => {
      if (a === 0) {
        for (var o = 0, l = r, u = r.length; o < u; o++)
          l[o](0);
        r.length = 0;
      } else if (a.tag === 0)
        t = a[0];
      else {
        n = !1;
        for (var p = 0, m = r, d = r.length; p < d; p++)
          m[p](a);
      }
    }), i(T((a) => {
      if (a === 1) {
        var o = r.indexOf(i);
        o > -1 && (r = r.slice()).splice(o, 1), r.length || t(1);
      } else n || (n = !0, t(0));
    }));
  };
}
function be(e) {
  return (r) => (t) => {
    var n = A, i = A, a = !1, o = !1, l = !1, u = !1;
    r((p) => {
      u || (p === 0 ? (u = !0, l || t(0)) : p.tag === 0 ? n = p[0] : (l && (i(1), i = A), a ? a = !1 : (a = !0, n(0)), function(d) {
        l = !0, d((y) => {
          l && (y === 0 ? (l = !1, u ? t(0) : a || (a = !0, n(0))) : y.tag === 0 ? (o = !1, (i = y[0])(0)) : (t(y), o ? o = !1 : i(0)));
        });
      }(e(p[0]))));
    }), t(T((p) => {
      p === 1 ? (u || (u = !0, n(1)), l && (l = !1, i(1))) : (!u && !a && (a = !0, n(0)), l && !o && (o = !0, i(0)));
    }));
  };
}
function $e(e) {
  return (r) => (t) => {
    var n = A, i = !1, a = 0;
    r((o) => {
      i || (o === 0 ? (i = !0, t(0)) : o.tag === 0 ? n = o[0] : a++ < e ? (t(o), !i && a >= e && (i = !0, t(0), n(1))) : t(o));
    }), t(T((o) => {
      o === 1 && !i ? (i = !0, n(1)) : o === 0 && !i && a < e && n(0);
    }));
  };
}
function je(e) {
  return (r) => (t) => {
    var n = A, i = A, a = !1;
    r((o) => {
      a || (o === 0 ? (a = !0, i(1), t(0)) : o.tag === 0 ? (n = o[0], e((l) => {
        l === 0 || (l.tag === 0 ? (i = l[0])(0) : (a = !0, i(1), n(1), t(0)));
      })) : t(o));
    }), t(T((o) => {
      o === 1 && !a ? (a = !0, n(1), i(1)) : a || n(0);
    }));
  };
}
function nr(e, r) {
  return (t) => (n) => {
    var i = A, a = !1;
    t((o) => {
      a || (o === 0 ? (a = !0, n(0)) : o.tag === 0 ? (i = o[0], n(o)) : e(o[0]) ? n(o) : (a = !0, n(o), n(0), i(1)));
    });
  };
}
function ir(e) {
  return (r) => e()(r);
}
function Me(e) {
  return (r) => {
    var t = e[Ne()] && e[Ne()]() || e, n = !1, i = !1, a = !1, o;
    r(T(async (l) => {
      if (l === 1)
        n = !0, t.return && t.return();
      else if (i)
        a = !0;
      else {
        for (a = i = !0; a && !n; )
          if ((o = await t.next()).done)
            n = !0, t.return && await t.return(), r(0);
          else
            try {
              a = !1, r(J(o.value));
            } catch (u) {
              if (t.throw)
                (n = !!(await t.throw(u)).done) && r(0);
              else
                throw u;
            }
        i = !1;
      }
    }));
  };
}
function ar(e) {
  return e[Symbol.asyncIterator] ? Me(e) : (r) => {
    var t = e[Symbol.iterator](), n = !1, i = !1, a = !1, o;
    r(T((l) => {
      if (l === 1)
        n = !0, t.return && t.return();
      else if (i)
        a = !0;
      else {
        for (a = i = !0; a && !n; )
          if ((o = t.next()).done)
            n = !0, t.return && t.return(), r(0);
          else
            try {
              a = !1, r(J(o.value));
            } catch (u) {
              if (t.throw)
                (n = !!t.throw(u).done) && r(0);
              else
                throw u;
            }
        i = !1;
      }
    }));
  };
}
var or = ar;
function le(e) {
  return (r) => {
    var t = !1;
    r(T((n) => {
      n === 1 ? t = !0 : t || (t = !0, r(J(e)), r(0));
    }));
  };
}
function sr(e) {
  return (r) => {
    var t = !1, n = e({
      next(i) {
        t || r(J(i));
      },
      complete() {
        t || (t = !0, r(0));
      }
    });
    r(T((i) => {
      i === 1 && !t && (t = !0, n());
    }));
  };
}
function xe() {
  var e, r;
  return {
    source: Q(sr((t) => (e = t.next, r = t.complete, Pe))),
    next(t) {
      e && e(t);
    },
    complete() {
      r && r();
    }
  };
}
function X(e) {
  return (r) => {
    var t = A, n = !1;
    return r((i) => {
      i === 0 ? n = !0 : i.tag === 0 ? (t = i[0])(0) : n || (e(i[0]), t(0));
    }), {
      unsubscribe() {
        n || (n = !0, t(1));
      }
    };
  };
}
function lr(e) {
  X((r) => {
  })(e);
}
function ur(e) {
  return new Promise((r) => {
    var t = A, n;
    e((i) => {
      i === 0 ? Promise.resolve(n).then(r) : i.tag === 0 ? (t = i[0])(0) : (n = i[0], t(0));
    });
  });
}
var cr = (e) => e && e.message && (e.extensions || e.name === "GraphQLError") ? e : typeof e == "object" && e.message ? new ce(e.message, e.nodes, e.source, e.positions, e.path, e, e.extensions || {}) : new ce(e);
class Ee extends Error {
  constructor(r) {
    var t = (r.graphQLErrors || []).map(cr), n = ((i, a) => {
      var o = "";
      if (i)
        return `[Network] ${i.message}`;
      if (a)
        for (var l of a)
          o && (o += `
`), o += `[GraphQL] ${l.message}`;
      return o;
    })(r.networkError, t);
    super(n), this.name = "CombinedError", this.message = n, this.graphQLErrors = t, this.networkError = r.networkError, this.response = r.response;
  }
  toString() {
    return this.message;
  }
}
var W = (e, r) => {
  for (var t = 0 | (r || 5381), n = 0, i = 0 | e.length; n < i; n++)
    t = (t << 5) + t + e.charCodeAt(n);
  return t;
}, F = /* @__PURE__ */ new Set(), we = /* @__PURE__ */ new WeakMap(), M = (e, r) => {
  if (e === null || F.has(e))
    return "null";
  if (typeof e != "object")
    return JSON.stringify(e) || "";
  if (e.toJSON)
    return M(e.toJSON(), r);
  if (Array.isArray(e)) {
    var t = "[";
    for (var n of e)
      t.length > 1 && (t += ","), t += M(n, r) || "null";
    return t += "]";
  } else if (!r && (re !== U && e instanceof re || te !== U && e instanceof te))
    return "null";
  var i = Object.keys(e).sort();
  if (!i.length && e.constructor && Object.getPrototypeOf(e).constructor !== Object.prototype.constructor) {
    var a = we.get(e) || Math.random().toString(36).slice(2);
    return we.set(e, a), M({
      __key: a
    }, r);
  }
  F.add(e);
  var o = "{";
  for (var l of i) {
    var u = M(e[l], r);
    u && (o.length > 1 && (o += ","), o += M(l, r) + ":" + u);
  }
  return F.delete(e), o += "}";
}, ve = (e, r, t) => {
  if (!(t == null || typeof t != "object" || t.toJSON || F.has(t))) if (Array.isArray(t))
    for (var n = 0, i = t.length; n < i; n++)
      ve(e, `${r}.${n}`, t[n]);
  else if (t instanceof re || t instanceof te)
    e.set(r, t);
  else {
    F.add(t);
    for (var a of Object.keys(t))
      ve(e, `${r}.${a}`, t[a]);
  }
}, ee = (e, r) => (F.clear(), M(e, r || !1));
class U {
}
var re = typeof File < "u" ? File : U, te = typeof Blob < "u" ? Blob : U, fr = /("{3}[\s\S]*"{3}|"(?:\\.|[^"])*")/g, dr = /(?:#[^\n\r]+)?(?:[\r\n]+|$)/g, vr = (e, r) => r % 2 == 0 ? e.replace(dr, `
`) : e, Oe = (e) => e.split(fr).map(vr).join("").trim(), Se = /* @__PURE__ */ new Map(), K = /* @__PURE__ */ new Map(), ie = (e) => {
  var r;
  return typeof e == "string" ? r = Oe(e) : e.loc && K.get(e.__key) === e ? r = e.loc.source.body : (r = Se.get(e) || Oe(Xe(e)), Se.set(e, r)), typeof e != "string" && !e.loc && (e.loc = {
    start: 0,
    end: r.length,
    source: {
      body: r,
      name: "gql",
      locationOffset: {
        line: 1,
        column: 1
      }
    }
  }), r;
}, Ae = (e) => {
  var r;
  if (e.documentId)
    r = W(e.documentId);
  else if (r = W(ie(e)), e.definitions) {
    var t = Be(e);
    t && (r = W(`
# ${t}`, r));
  }
  return r;
}, pe = (e) => {
  var r, t;
  return typeof e == "string" ? (r = Ae(e), t = K.get(r) || Ye(e)) : (r = e.__key || Ae(e), t = K.get(r) || e), t.loc || ie(t), t.__key = r, K.set(r, t), t;
}, ue = (e, r, t) => {
  var n = r || {}, i = pe(e), a = ee(n, !0), o = i.__key;
  return a !== "{}" && (o = W(a, o)), {
    key: o,
    query: i,
    variables: n,
    extensions: t
  };
}, Be = (e) => {
  for (var r of e.definitions)
    if (r.kind === Y.OPERATION_DEFINITION)
      return r.name ? r.name.value : void 0;
}, pr = (e) => {
  for (var r of e.definitions)
    if (r.kind === Y.OPERATION_DEFINITION)
      return r.operation;
}, De = (e, r, t) => {
  if (!("data" in r || "errors" in r && Array.isArray(r.errors)))
    throw new Error("No Content");
  var n = e.kind === "subscription";
  return {
    operation: e,
    data: r.data,
    error: Array.isArray(r.errors) ? new Ee({
      graphQLErrors: r.errors,
      response: t
    }) : void 0,
    extensions: r.extensions ? {
      ...r.extensions
    } : void 0,
    hasNext: r.hasNext == null ? n : r.hasNext,
    stale: !1
  };
}, he = (e, r) => {
  if (typeof e == "object" && e != null && (!e.constructor || e.constructor === Object || Array.isArray(e))) {
    e = Array.isArray(e) ? [...e] : {
      ...e
    };
    for (var t of Object.keys(r))
      e[t] = he(e[t], r[t]);
    return e;
  }
  return r;
}, hr = (e, r, t, n) => {
  var i = e.error ? e.error.graphQLErrors : [], a = !!e.extensions || !!(r.payload || r).extensions, o = {
    ...e.extensions,
    ...(r.payload || r).extensions
  }, l = r.incremental;
  "path" in r && (l = [r]);
  var u = {
    data: e.data
  };
  if (l) {
    var p = function(d) {
      Array.isArray(d.errors) && i.push(...d.errors), d.extensions && (Object.assign(o, d.extensions), a = !0);
      var y = "data", N = u, k = [];
      if (d.path)
        k = d.path;
      else if (n) {
        var D = n.find((h) => h.id === d.id);
        d.subPath ? k = [...D.path, ...d.subPath] : k = D.path;
      }
      for (var w = 0, q = k.length; w < q; y = k[w++])
        N = N[y] = Array.isArray(N[y]) ? [...N[y]] : {
          ...N[y]
        };
      if (d.items)
        for (var R = +y >= 0 ? y : 0, I = 0, s = d.items.length; I < s; I++)
          N[R + I] = he(N[R + I], d.items[I]);
      else d.data !== void 0 && (N[y] = he(N[y], d.data));
    };
    for (var m of l)
      p(m);
  } else
    u.data = (r.payload || r).data || e.data, i = r.errors || r.payload && r.payload.errors || i;
  return {
    operation: e.operation,
    data: u.data,
    error: i.length ? new Ee({
      graphQLErrors: i,
      response: t
    }) : void 0,
    extensions: a ? o : void 0,
    hasNext: r.hasNext != null ? r.hasNext : e.hasNext,
    stale: !1
  };
}, mr = (e, r, t) => ({
  operation: e,
  data: void 0,
  error: new Ee({
    networkError: r,
    response: t
  }),
  extensions: void 0,
  hasNext: !1,
  stale: !1
});
function yr(e) {
  var r = {
    query: void 0,
    documentId: void 0,
    operationName: Be(e.query),
    variables: e.variables || void 0,
    extensions: e.extensions
  };
  return "documentId" in e.query && e.query.documentId && (!e.query.definitions || !e.query.definitions.length) ? r.documentId = e.query.documentId : (!e.extensions || !e.extensions.persistedQuery || e.extensions.persistedQuery.miss) && (r.query = ie(e.query)), r;
}
var gr = (e, r) => {
  var t = e.kind === "query" && e.context.preferGetMethod;
  if (!t || !r)
    return e.context.url;
  var n = kr(e.context.url);
  for (var i in r) {
    var a = r[i];
    a && n[1].set(i, typeof a == "object" ? ee(a) : a);
  }
  var o = n.join("?");
  return o.length > 2047 && t !== "force" ? (e.context.preferGetMethod = !1, e.context.url) : o;
}, kr = (e) => {
  var r = e.indexOf("?");
  return r > -1 ? [e.slice(0, r), new URLSearchParams(e.slice(r + 1))] : [e, new URLSearchParams()];
}, Er = (e, r) => {
  if (r && !(e.kind === "query" && e.context.preferGetMethod)) {
    var t = ee(r), n = ((l) => {
      var u = /* @__PURE__ */ new Map();
      return (re !== U || te !== U) && (F.clear(), ve(u, "variables", l)), u;
    })(r.variables);
    if (n.size) {
      var i = new FormData();
      i.append("operations", t), i.append("map", ee({
        ...[...n.keys()].map((l) => [l])
      }));
      var a = 0;
      for (var o of n.values())
        i.append("" + a++, o);
      return i;
    }
    return t;
  }
}, Nr = (e, r) => {
  var t = {
    accept: e.kind === "subscription" ? "text/event-stream, multipart/mixed" : "application/graphql-response+json, application/graphql+json, application/json, text/event-stream, multipart/mixed"
  }, n = (typeof e.context.fetchOptions == "function" ? e.context.fetchOptions() : e.context.fetchOptions) || {};
  if (n.headers)
    if (((o) => "has" in o && !Object.keys(o).length)(n.headers))
      n.headers.forEach((o, l) => {
        t[l] = o;
      });
    else if (Array.isArray(n.headers))
      n.headers.forEach((o, l) => {
        Array.isArray(o) ? t[o[0]] ? t[o[0]] = `${t[o[0]]},${o[1]}` : t[o[0]] = o[1] : t[l] = o;
      });
    else
      for (var i in n.headers)
        t[i.toLowerCase()] = n.headers[i];
  var a = Er(e, r);
  return typeof a == "string" && !t["content-type"] && (t["content-type"] = "application/json"), {
    ...n,
    method: a ? "POST" : "GET",
    body: a,
    headers: t
  };
}, _r = typeof TextDecoder < "u" ? new TextDecoder() : null, br = /boundary="?([^=";]+)"?/i, xr = /data: ?([^\n]+)/, Te = (e) => e.constructor.name === "Buffer" ? e.toString() : _r.decode(e);
async function* Ie(e) {
  if (e.body[Symbol.asyncIterator])
    for await (var r of e.body)
      yield Te(r);
  else {
    var t = e.body.getReader(), n;
    try {
      for (; !(n = await t.read()).done; )
        yield Te(n.value);
    } finally {
      t.cancel();
    }
  }
}
async function* Ce(e, r) {
  var t = "", n;
  for await (var i of e)
    for (t += i; (n = t.indexOf(r)) > -1; )
      yield t.slice(0, n), t = t.slice(n + r.length);
}
async function* wr(e, r, t) {
  var n = !0, i = null, a;
  try {
    yield await Promise.resolve();
    var o = (a = await (e.context.fetch || fetch)(r, t)).headers.get("Content-Type") || "", l;
    /multipart\/mixed/i.test(o) ? l = async function* (d, y) {
      var N = d.match(br), k = "--" + (N ? N[1] : "-"), D = !0, w;
      for await (var q of Ce(Ie(y), `\r
` + k)) {
        if (D) {
          D = !1;
          var R = q.indexOf(k);
          if (R > -1)
            q = q.slice(R + k.length);
          else
            continue;
        }
        try {
          yield w = JSON.parse(q.slice(q.indexOf(`\r
\r
`) + 4));
        } catch (I) {
          if (!w)
            throw I;
        }
        if (w && w.hasNext === !1)
          break;
      }
      w && w.hasNext !== !1 && (yield {
        hasNext: !1
      });
    }(o, a) : /text\/event-stream/i.test(o) ? l = async function* (d) {
      var y;
      for await (var N of Ce(Ie(d), `

`)) {
        var k = N.match(xr);
        if (k) {
          var D = k[1];
          try {
            yield y = JSON.parse(D);
          } catch (w) {
            if (!y)
              throw w;
          }
          if (y && y.hasNext === !1)
            break;
        }
      }
      y && y.hasNext !== !1 && (yield {
        hasNext: !1
      });
    }(a) : /text\//i.test(o) ? l = async function* (d) {
      var y = await d.text();
      try {
        var N = JSON.parse(y);
        process.env.NODE_ENV !== "production" && console.warn('Found response with content-type "text/plain" but it had a valid "application/json" response.'), yield N;
      } catch {
        throw new Error(y);
      }
    }(a) : l = async function* (d) {
      yield JSON.parse(await d.text());
    }(a);
    var u;
    for await (var p of l)
      p.pending && !i ? u = p.pending : p.pending && (u = [...u, ...p.pending]), i = i ? hr(i, p, a, u) : De(e, p, a), n = !1, yield i, n = !0;
    i || (yield i = De(e, {}, a));
  } catch (m) {
    if (!n)
      throw m;
    yield mr(e, a && (a.status < 200 || a.status >= 300) && a.statusText ? new Error(a.statusText) : m, a);
  }
}
function Or(e, r, t) {
  var n;
  return typeof AbortController < "u" && (t.signal = (n = new AbortController()).signal), Fe(() => {
    n && n.abort();
  })(V((i) => !!i)(Me(wr(e, r, t))));
}
function Ve(e) {
  var r = (t) => e(t);
  return r.toPromise = () => ur($e(1)(V((t) => !t.stale && !t.hasNext)(r))), r.then = (t, n) => r.toPromise().then(t, n), r.subscribe = (t) => X(t)(r), r;
}
function qe(e, r, t) {
  return {
    ...r,
    kind: e,
    context: r.context ? {
      ...r.context,
      ...t
    } : t || r.context
  };
}
var Sr = () => {
};
function $(e) {
  for (var r = /* @__PURE__ */ new Map(), t = [], n = [], i = Array.isArray(e) ? e[0] : e || "", a = 1; a < arguments.length; a++) {
    var o = arguments[a];
    o && o.definitions ? n.push(o) : i += o, i += arguments[0][a];
  }
  n.unshift(pe(i));
  for (var l of n)
    for (var u of l.definitions)
      if (u.kind === Y.FRAGMENT_DEFINITION) {
        var p = u.name.value, m = ie(u);
        r.has(p) ? process.env.NODE_ENV !== "production" && r.get(p) !== m && console.warn("[WARNING: Duplicate Fragment] A fragment with name `" + p + "` already exists in this document.\nWhile fragment names may not be unique across your source, each name must be unique per document.") : (r.set(p, m), t.push(u));
      } else
        t.push(u);
  return pe({
    kind: Y.DOCUMENT,
    definitions: t
  });
}
var Ar = ({ forward: e, dispatchDebug: r }) => (t) => {
  var n = Re((a) => {
    var o = yr(a), l = gr(a, o), u = Nr(a, o);
    process.env.NODE_ENV !== "production" && r({
      type: "fetchRequest",
      message: "A fetch request is being executed.",
      operation: a,
      data: {
        url: l,
        fetchOptions: u
      },
      source: "fetchExchange"
    });
    var p = je(V((m) => m.kind === "teardown" && m.key === a.key)(t))(Or(a, l, u));
    return process.env.NODE_ENV !== "production" ? ke((m) => {
      var d = m.data ? void 0 : m.error;
      process.env.NODE_ENV !== "production" && r({
        type: d ? "fetchError" : "fetchSuccess",
        message: `A ${d ? "failed" : "successful"} fetch response has been returned.`,
        operation: a,
        data: {
          url: l,
          fetchOptions: u,
          value: d || m
        },
        source: "fetchExchange"
      });
    })(p) : p;
  })(V((a) => a.kind !== "teardown" && (a.kind !== "subscription" || !!a.context.fetchSubscriptions))(t)), i = e(V((a) => a.kind === "teardown" || a.kind === "subscription" && !a.context.fetchSubscriptions)(t));
  return de([n, i]);
}, Dr = (e) => ({ client: r, forward: t, dispatchDebug: n }) => e.reduceRight((i, a) => {
  var o = !1;
  return a({
    client: r,
    forward(l) {
      if (process.env.NODE_ENV !== "production") {
        if (o)
          throw new Error("forward() must only be called once in each Exchange.");
        o = !0;
      }
      return Q(i(Q(l)));
    },
    dispatchDebug(l) {
      process.env.NODE_ENV !== "production" && n({
        timestamp: Date.now(),
        source: a.name,
        ...l
      });
    }
  });
}, t), Tr = ({ dispatchDebug: e }) => (r) => (process.env.NODE_ENV !== "production" && (r = ke((t) => {
  if (t.kind !== "teardown" && process.env.NODE_ENV !== "production") {
    var n = `No exchange has handled operations of kind "${t.kind}". Check whether you've added an exchange responsible for these operations.`;
    process.env.NODE_ENV !== "production" && e({
      type: "fallbackCatch",
      message: n,
      operation: t,
      source: "fallbackExchange"
    }), console.warn(n);
  }
})(r)), V((t) => !1)(r)), Ir = function e(r) {
  if (process.env.NODE_ENV !== "production" && !r.url)
    throw new Error("You are creating an urql-client without a url.");
  var t = 0, n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set(), o = [], l = {
    url: r.url,
    fetchSubscriptions: r.fetchSubscriptions,
    fetchOptions: r.fetchOptions,
    fetch: r.fetch,
    preferGetMethod: r.preferGetMethod,
    requestPolicy: r.requestPolicy || "cache-first"
  }, u = xe();
  function p(s) {
    (s.kind === "mutation" || s.kind === "teardown" || !a.has(s.key)) && (s.kind === "teardown" ? a.delete(s.key) : s.kind !== "mutation" && a.add(s.key), u.next(s));
  }
  var m = !1;
  function d(s) {
    if (s && p(s), !m) {
      for (m = !0; m && (s = o.shift()); )
        p(s);
      m = !1;
    }
  }
  var y = (s) => {
    var h = je(V((c) => c.kind === "teardown" && c.key === s.key)(u.source))(V((c) => c.operation.kind === s.kind && c.operation.key === s.key && (!c.operation.context._instance || c.operation.context._instance === s.context._instance))(I));
    return s.kind !== "query" ? h = nr((c) => !!c.hasNext)(h) : h = be((c) => {
      var O = le(c);
      return c.stale || c.hasNext ? O : de([O, rr(() => (c.stale = !0, c))($e(1)(V((ae) => ae.key === s.key)(u.source)))]);
    })(h), s.kind !== "mutation" ? h = Fe(() => {
      a.delete(s.key), n.delete(s.key), i.delete(s.key), m = !1;
      for (var c = o.length - 1; c >= 0; c--)
        o[c].key === s.key && o.splice(c, 1);
      p(qe("teardown", s, s.context));
    })(ke((c) => {
      if (c.stale) {
        if (!c.hasNext)
          a.delete(s.key);
        else
          for (var O of o)
            if (O.key === c.operation.key) {
              a.delete(O.key);
              break;
            }
      } else c.hasNext || a.delete(s.key);
      n.set(s.key, c);
    })(h)) : h = _e(() => {
      p(s);
    })(h), Q(h);
  }, N = this instanceof e ? this : Object.create(e.prototype), k = Object.assign(N, {
    suspense: !!r.suspense,
    operations$: u.source,
    reexecuteOperation(s) {
      if (s.kind === "teardown")
        d(s);
      else if (s.kind === "mutation")
        o.push(s), Promise.resolve().then(d);
      else if (i.has(s.key)) {
        for (var h = !1, c = 0; c < o.length; c++)
          o[c].key === s.key && (o[c] = s, h = !0);
        h || a.has(s.key) && s.context.requestPolicy !== "network-only" ? (a.delete(s.key), Promise.resolve().then(d)) : (o.push(s), Promise.resolve().then(d));
      }
    },
    createRequestOperation(s, h, c) {
      c || (c = {});
      var O;
      if (process.env.NODE_ENV !== "production" && s !== "teardown" && (O = pr(h.query)) !== s)
        throw new Error(`Expected operation of type "${s}" but found "${O}"`);
      return qe(s, h, {
        _instance: s === "mutation" ? t = t + 1 | 0 : void 0,
        ...l,
        ...c,
        requestPolicy: c.requestPolicy || l.requestPolicy,
        suspense: c.suspense || c.suspense !== !1 && k.suspense
      });
    },
    executeRequestOperation(s) {
      return s.kind === "mutation" ? Ve(y(s)) : Ve(ir(() => {
        var h = i.get(s.key);
        h || i.set(s.key, h = y(s)), h = _e(() => {
          d(s);
        })(h);
        var c = n.get(s.key);
        return s.kind === "query" && c && (c.stale || c.hasNext) ? be(le)(de([h, V((O) => O === n.get(s.key))(le(c))])) : h;
      }));
    },
    executeQuery(s, h) {
      var c = k.createRequestOperation("query", s, h);
      return k.executeRequestOperation(c);
    },
    executeSubscription(s, h) {
      var c = k.createRequestOperation("subscription", s, h);
      return k.executeRequestOperation(c);
    },
    executeMutation(s, h) {
      var c = k.createRequestOperation("mutation", s, h);
      return k.executeRequestOperation(c);
    },
    readQuery(s, h, c) {
      var O = null;
      return X((ae) => {
        O = ae;
      })(k.query(s, h, c)).unsubscribe(), O;
    },
    query: (s, h, c) => k.executeQuery(ue(s, h), c),
    subscription: (s, h, c) => k.executeSubscription(ue(s, h), c),
    mutation: (s, h, c) => k.executeMutation(ue(s, h), c)
  }), D = Sr;
  if (process.env.NODE_ENV !== "production") {
    var { next: w, source: q } = xe();
    k.subscribeToDebugTarget = (s) => X(s)(q), D = w;
  }
  var R = Dr(r.exchanges), I = Q(R({
    client: k,
    dispatchDebug: D,
    forward: Tr({
      dispatchDebug: D
    })
  })(u.source));
  return lr(I), k;
};
const ne = {
  [G.ETH_MAINNET]: "https://data.deorderbook.com/homestead/hasura/v1/graphql",
  [G.ETH_SEPOLIA]: "https://testnet-data.deorderbook.com/sepolia/hasura/v1/graphql",
  [G.SCROLL_SEPOLIA]: "https://testnet-data.deorderbook.com/scroll-sepolia/hasura/v1/graphql"
}, me = (e) => {
  const r = e.indexOf(".com");
  return r !== -1 ? e.slice(0, r + 4) : e;
};
let ye = me(
  ne[G.ETH_MAINNET]
), ge = ne[G.ETH_MAINNET];
function Ur(e, r = {}) {
  const { urlFromEnv: t } = r;
  typeof t == "string" && /^(http:\/\/|https:\/\/)/.test(t) ? (ge = t, ye = me(t)) : (ge = ne[e], ye = me(ne[e]));
}
function Cr() {
  return ge;
}
function Vr() {
  return ye;
}
function j(e) {
  return new Ir({
    url: Cr(),
    exchanges: [Ar],
    fetchOptions: { ...e }
  });
}
const qr = $`
  query getTokenPrice($token: String!) {
    derived_token_price(where: { token: { _eq: $token } }) {
      token
      avg_price_usd
    }
  }
`;
async function Gr(e) {
  if (["DOB", "eDOB", "WBTC", "USDC", "ETH", "WETH"].includes(e)) {
    const t = e === "WETH" ? "eth" : e === "eDOB" ? "DOB" : e;
    return (await j().query(qr, {
      token: "token-" + t.toLowerCase()
    })).data.derived_token_price.at(0)?.avg_price_usd ?? "0";
  } else return "0";
}
const Lr = $`
  query GetLeaderBoard($limit: Int, $offset: Int) {
    applet_ui_leaderboard_latest(
      limit: $limit
      offset: $offset
      order_by: { rank: asc }
    ) {
      rank
      timestamp
      address
      block
      total_asset_value
      pnl
      rank_change
    }
  }
`;
async function Qr(e) {
  return j().query(Lr, e).then((t) => t.error ? (console.error(t.error.message), Promise.reject(t.error)) : t.data?.applet_ui_leaderboard_latest);
}
const Pr = $`
  query getLatestCurrentMetric {
    stats_current_metric(order_by: { block: desc }, limit: 1) {
      block
      timestamp
      accumulated_fees
      user_count
      active_user_count
      total_volume
      current_tvl
      open_interest
      total_buy
      total_sell
    }
  }
`;
async function Jr() {
  return j().query(Pr, {}).then((r) => r.error ? (console.error(r.error.message), Promise.reject(r.error)) : r.data?.stats_current_metric.at(0));
}
async function Hr(e) {
  return Ue(
    Vr() + "/sepolia/api/user/trade_history/" + e
  );
}
const Rr = $`
  query GetAllActiveBulletPrices {
    derived_active_bullet_price {
      bullet_id
      strike
      expiry_timestamp
      price
      currency
    }
  }
`;
async function Wr(e) {
  return j().query(Rr, e).then((t) => t.error ? (console.error(t.error.message), Promise.reject(t.error)) : t.data?.derived_active_bullet_price);
}
const Fr = $`
  query GetProcessorBlockHeight {
    processor_sync_status(where: { KEY: { _eq: "block_height" } }) {
      KEY
      value
    }
  }
`;
async function Kr() {
  const r = (await j().query(Fr, {})).data?.processor_sync_status;
  if (r && r.length > 0)
    return r.at(0)?.value;
}
const $r = $`
  query getCurrentAndFutureOptions {
    derived_current_and_future_options {
      id
      address
      bullet
      sniper
      strike_price
      start_timestamp
      start_block
      exercise_timestamp
      end_block
      option_type
      is_active
    }
  }
`;
async function Yr() {
  return j().query($r, {}).then((r) => r.error ? (console.error(r.error.message), Promise.reject(r.error)) : r.data?.derived_current_and_future_options);
}
const jr = $`
  mutation updateStrikePrice($poolId: String!, $newStrikePrice: String!) {
    update_sgd_option(
      _set: { strike_price: $newStrikePrice }
      where: { id: { _eq: $poolId } }
    ) {
      affected_rows
      returning {
        id
        strike_price
      }
    }
  }
`;
async function zr(e, r, t) {
  return j({
    headers: {
      "x-hasura-admin-secret": t
    }
  }).mutation(jr, {
    poolId: e,
    newStrikePrice: r
  }).then((i) => i.error ? (console.error(i.error), Promise.reject(i.error)) : i.data?.update_sgd_option);
}
export {
  Lr as APPLET_UI_LEADERBOARD_LATEST,
  ne as DEFAULT_BACKEND_URLS,
  Rr as DERIVED_ACTIVE_BULLET_PRICE,
  qr as GET_DERIVED_TOKEN_PRICE,
  $r as GET_LATEST_CURRENT_AND_FUTURE_OPTIONS_QUERY,
  Pr as GET_LATEST_CURRENT_METRIC_QUERY,
  Fr as GET_PROCESSOR_BLOCK_HEIGHT,
  jr as UPDATE_STRIKE_PRICE_MUTATION,
  Wr as getActiveBulletPrice,
  j as getBackendClient,
  Cr as getBackendURL,
  Vr as getBackendURLPrefix,
  Yr as getCurrentAndFutureOptions,
  Jr as getCurrentMetric,
  Qr as getLeaderBoard,
  Kr as getProcessorBlockHeight,
  Gr as getTokenPrice,
  Hr as getTradeHistory,
  Ur as setBackend,
  zr as updateStrikePrice
};
//# sourceMappingURL=index.mjs.map
